import { Profiles } from './Profiles'

// eslint-disable-next-line import/no-default-export
export default Profiles
